<template>
  <main>
    <md-card class="md-preview">
      <md-steppers md-active-step="contract" md-alternative md-linear>
        <md-step id="email" md-label="メール認証"></md-step>
        <md-step id="apply" md-label="必須事項の入力"></md-step>
        <md-step id="start" md-label="無料トライアルご利用開始"></md-step>
        <md-step id="contract" md-label="本契約の手続き"></md-step>
        <md-step id="startService" md-label="ご利用開始"></md-step>
      </md-steppers>

      <div class="md-layout">
        <div class="md-layout-item md-size-5 md-small-size-100"></div>
        <div class="md-layout-item md-size-90 md-small-size-100">
          <md-card-header>
            <div class="md-title">ご登録内容の確認</div>
            <div class="md-title text-error">※まだ本契約は完了しておりません。</div>
          </md-card-header>

          <!-- 登記情報提供サービスIDを認証 -->
          <md-card-header>
            <div class="md-title">登記情報提供サービスのアカウントを認証</div>
          </md-card-header>
          <md-card-content>
            <!-- 登記情報提供サービス-->
            <div class="md-layout md-gutter">
              <div class="md-layout md-layout-item md-alignment-center-left md-size-20 md-small-size-100">
                <label>登記情報提供サービスID</label>
              </div>
              <div class="md-layout-item md-size-40">
                <div class="md-layout md-alignment-center-space-between">
                  <md-field>
                    <label>{{ formData.t_service_id }}</label>
                  </md-field>
                </div>
              </div>
            </div>
          </md-card-content>

          <!-- 申込内容 -->
          <md-card-header>
            <div class="md-title">申込内容</div>
          </md-card-header>
          <md-card-content>
            <!-- 法⼈名、支店名 -->
            <div class="md-layout md-gutter">
              <div class="md-layout md-layout-item md-alignment-center-left md-size-20 md-small-size-100">
                <label>法⼈名</label>
              </div>
              <div class="md-layout-item">
                <div class="md-layout md-gutter">
                  <div class="md-layout-item">
                    <md-field>
                      <label>{{ formData.corporation.name }}</label>
                    </md-field>
                  </div>
                  <div class="md-layout-item">
                    <md-field>
                      <label>{{ formData.corporation.branch_name }}</label>
                    </md-field>
                  </div>
                </div>
              </div>
            </div>

            <!-- 所在地 -->
            <div class="md-layout md-gutter">
              <div class="md-layout md-layout-item md-alignment-center-left md-size-20 md-small-size-100">
                <label>所在地</label>
              </div>
              <div class="md-layout-item md-size-20 md-small-size-100">
                <md-field>
                  <label>〒{{ postalCodeFormat(formData.corporation.postal) }}</label>
                </md-field>
              </div>
            </div>
            <div class="md-layout md-gutter">
              <div class="md-layout-item md-size-20 md-small-size-100"></div>
              <div class="md-layout-item md-size-40 md-small-size-50">
                <md-field>
                  <label>{{ formData.corporation.pref }}{{
                      formData.corporation.city
                    }}{{ formData.corporation.street_name }}</label>
                </md-field>
              </div>
              <div class="md-layout-item md-size-40 md-small-size-50">
                <md-field>
                  <label>{{ formData.corporation.street_number }}</label>
                </md-field>
              </div>
            </div>
            <div class="md-layout md-gutter">
              <div class="md-layout-item md-size-20 md-small-size-100"></div>
              <div class="md-layout-item md-size-40 md-small-size-50">
                <md-field>
                  <label>{{ formData.corporation.etc }}</label>
                </md-field>
              </div>
            </div>

            <!-- ご担当者名 -->
            <div class="md-layout md-gutter">
              <div class="md-layout md-layout-item md-alignment-center-left md-size-20 md-small-size-100">
                <label>ご担当者名</label>
              </div>
              <div class="md-layout-item md-size-30">
                <md-field>
                  <label>{{ formData.account.name_last }}{{ formData.account.name_first }}</label>
                </md-field>
              </div>
            </div>

            <!-- ご連絡先 -->
            <div class="md-layout md-gutter">
              <div class="md-layout md-layout-item md-alignment-center-left md-size-20 md-small-size-100">
                <label>ご連絡先</label>
              </div>
              <div class="md-layout-item md-size-30">
                <md-field>
                  <label>{{ formData.account.email }}</label>
                </md-field>
              </div>
              <div class="md-layout md-layout-item md-alignment-center-left md-size-10 md-small-size-100">
                <label>電話番号</label>
              </div>
              <div class="md-layout-item">
                <md-field>
                  <label>{{ formData.account.tel }}</label>
                </md-field>
              </div>
            </div>
          </md-card-content>

          <!-- 決済方法 -->
          <md-card-header>
            <div class="md-title">決済方法</div>
          </md-card-header>
          <md-card-content>
            <!-- 支払情報の名称 -->
            <div class="md-layout md-gutter" v-show="showPaymentLabel()">
              <div class="md-layout md-layout-item md-alignment-center-left md-size-20 md-small-size-100">
                <label>支払情報の名称</label>
              </div>
              <div class="md-layout-item md-size-30 md-small-size-100">
                <md-field>
                  <label>{{ formData.label }}</label>
                </md-field>
              </div>
            </div>

            <!-- 決済方法 -->
            <div class="md-layout md-gutter">
              <div class="md-layout md-layout-item md-alignment-center-left md-size-20 md-small-size-100">
                <label>決済方法</label>
              </div>
              <div class="md-layout-item md-size-30 md-small-size-100">
                <md-field>
                  <label>{{ getBillMethodName(formData.bill_method) }}</label>
                </md-field>
              </div>
            </div>


            <!-- カード情報 -->
            <div class="md-layout md-gutter" v-if="formData.bill_method === billingMethodCreditCard">
              <div class="md-layout md-layout-item md-alignment-center-left md-size-20 md-small-size-100">
                <label>カード情報</label>
              </div>
              <div class="md-layout-item md-size-30 md-small-size-100">
                <md-field>
                  <label>{{ formData.cardNumber }}</label>
                </md-field>
              </div>
            </div>
          </md-card-content>

          <!-- 請求書の送付方法 -->
          <md-card-header>
            <div class="md-title">請求書の送付方法</div>
          </md-card-header>
          <md-card-content>
            <div class="md-layout md-gutter">
              <div class="md-layout md-layout-item md-alignment-center-left md-size-20 md-small-size-100">
                <label>請求書の送付方法</label>
              </div>
              <div class="md-layout-item md-small-size-100">
                <md-field>
                  <label>{{ getBillViaName(formData.bill_via) }}</label>
                </md-field>
              </div>
            </div>

            <!-- ご連絡先-->
            <div class="md-layout md-gutter">
              <div class="md-layout md-layout-item md-alignment-center-left md-size-20 md-small-size-100">
                <label>宛名</label>
              </div>
              <div class="md-layout-item">
                <md-field>
                  <label>{{ formData.name1 }}</label>
                </md-field>
              </div>
              <div class="md-layout-item">
                <md-field>
                  <label>{{ formData.name2 }}</label>
                </md-field>
              </div>
            </div>
            <div class="md-layout md-gutter">
              <div class="md-layout-item md-size-20 md-small-size-100"></div>
              <div class="md-layout-item md-size-30 md-small-size-100">
                <md-field>
                  <label>{{ formData.name3 }}</label>
                </md-field>
              </div>
            </div>

            <!-- 所在地-->
            <div class="md-layout md-gutter" v-if="isBillingWithFee()">
              <div class="md-layout md-layout-item md-alignment-center-left md-size-20 md-small-size-100">
                <label>所在地</label>
              </div>
              <div class="md-layout-item md-size-25 md-small-size-100">
                <md-field>
                  <label>〒{{ postalCodeFormat(formData.postal) }}</label>
                </md-field>
              </div>
            </div>
            <div class="md-layout md-gutter" v-if="isBillingWithFee()">
              <div class="md-layout-item md-size-20 md-small-size-100"></div>
              <div class="md-layout-item md-size-40 md-small-size-50">
                <md-field>
                  <label>{{ formData.pref }}{{ formData.city }}{{ formData.street_name }}</label>
                </md-field>
              </div>
              <div class="md-layout-item md-size-40 md-small-size-50">
                <md-field>
                  <label>{{ formData.street_number }}</label>
                </md-field>
              </div>
            </div>
            <div class="md-layout md-gutter" v-if="isBillingWithFee()">
              <div class="md-layout-item md-size-20 md-small-size-100"></div>
              <div class="md-layout-item md-size-40 md-small-size-50">
                <md-field>
                  <label>{{ formData.etc }}</label>
                </md-field>
              </div>
            </div>

            <!-- メールアドレス-->
            <div class="md-layout md-gutter">
              <div class="md-layout md-layout-item md-alignment-center-left md-size-20 md-small-size-100">
                <label>メールアドレス</label></div>
              <div class="md-layout-item md-size-30 md-small-size-100">
                <md-field>
                  <label>{{ formData.email }}</label>
                </md-field>
              </div>
            </div>
            <div class="md-layout md-gutter">
              <div class="md-layout md-layout-item md-alignment-center-left md-size-20 md-small-size-100">
              </div>
              <div class="md-layout-item md-size-40 md-small-size-100">
                <div class="md-layout-item d-flex"
                     v-for="(additionalAddressItem, index) in formData.additionalAddresses"
                     :key="'additionalAddresses_' + index">
                  <div class="md-field d-block" style="padding-top: 0; margin: 0;">
                    <md-field>
                      <label>{{ additionalAddressItem }}</label>
                    </md-field>
                  </div>
                </div>
              </div>
            </div>
          </md-card-content>


          <!-- その他-->
          <md-card-content>
            <!-- 申し込みのきっかけ -->
            <div class="md-layout md-gutter">
              <div class="md-layout md-layout-item md-alignment-center-left md-size-20 md-small-size-100">
                <label>申し込みのきっかけ</label>
              </div>
              <div class="md-layout-item md-size-30 md-small-size-100">
                <md-field>
                  <label>{{ formData.contract.reason }}</label>
                </md-field>
              </div>
            </div>
          </md-card-content>

          <!-- 利用規約-->
          <md-card-content>
            <div class="md-layout md-gutter">
              <div class="md-layout md-layout-item md-alignment-center-left md-size-20 md-small-size-100">
                <label>利用規約の確認</label>
              </div>
              <div class="md-layout-item md-size-30">
                <md-field>
                  <label v-if="formData.apply">上記利用規約に同意します</label>
                </md-field>
              </div>
            </div>
          </md-card-content>

          <md-card-actions>
            <div class="md-layout md-alignment-top-center">
              <md-button type="button" class="md-button md-raised" :disabled="sending" @click="backToList()">
                <md-icon>arrow_left</md-icon>
                <span>入力画面へ戻る</span>
              </md-button>
            </div>
            <div class="md-layout md-alignment-top-center">
              <md-button type="submit" class="md-button md-primary md-raised" :disabled="sending"
                         @click="showFeeExplanation = true">
                <span>この内容で登録する</span>
                <md-icon>arrow_right</md-icon>
              </md-button>
            </div>
          </md-card-actions>
        </div>
      </div>

    </md-card>

    <!--登録完了メッセージ-->
    <md-dialog :md-active.sync="showRegistered">
      <md-dialog-content>
        登録が完了しました
      </md-dialog-content>
      <md-dialog-actions>
        <md-button class="md-primary md-raised" @click="closeRegisteredDialog">
          <span>閉じる</span>
        </md-button>
      </md-dialog-actions>
    </md-dialog>

    <!--本契約についてダイアログ-->
    <md-dialog :md-active.sync="showFeeExplanation">
      <md-dialog-title>本契約について</md-dialog-title>
      <md-dialog-content>
        登録すると月額料金が発生します。<br/>
        ￥12,000/月（1ID）（請求書郵送をご希望の場合：別途￥300/月）※税抜<br/>
      </md-dialog-content>
      <md-dialog-actions>
        <md-button class="md-primary md-raised" @click="register()">
          <span>登録する</span>
          <md-icon>arrow_right</md-icon>
        </md-button>
      </md-dialog-actions>
      <loading-spinner-overlay v-if="sending" :background="'#CCCCCC'"></loading-spinner-overlay>
    </md-dialog>
  </main>
</template>

<script>
import FlashMessage             from '../../../components/FlashMessage';
import Common                   from '../../../modules/common';
import CommonMixin              from '../../../mixins/commonMixin';
import {validationMixin}        from 'vuelidate'
import {
  apiClientWithUserToken,
  apiClientWithUserToken as apiClient,
  apiList,
}                               from '../../../modules/apiClient';
import LoadingSpinner           from '../../../components/LoadingSpinner';
import LoadingSpinnerOverlay    from '../../../components/LoadingSpinnerOverlay';
import ActivationModal          from '../../../components/ActivationModal';
import {mapActions, mapGetters} from 'vuex';

export default {
  name      : "UserPaymentNewPreview",
  components: {LoadingSpinnerOverlay, LoadingSpinner, FlashMessage, ActivationModal},
  mixins    : [CommonMixin, validationMixin],
  data      : () => ({
    showFeeExplanation     : false,
    showRegistered         : false,
    isTrialUser            : false,
    isTrialEnd             : false,
    billingMethodCreditCard: Common.billingMethodCreditCard,
  }),
  created() {
    this.initDisplay();
  },
  mounted() {
    this.saveValidateResponse([]);
    this.saveErrorMessages([]);
    if (this.formData === null) {
      return this.backToList();
    }
    this.scrollToTop();
  },
  computed: {
    ...mapGetters('payments', {
      formData: 'formData',
    }),
  },
  methods : {
    ...mapActions('paymentNewError', [
      'saveValidateResponse',
      'saveErrorMessages',
    ]),
    ...mapActions('payments', [
      'saveFormData',
    ]),
    backToList() {
      localStorage.setItem(Common.localStorageKeys.paymentNew.verify, 'ContractPreview');
      this.$router.replace({name: 'BackendUserPaymentContract'}).then();
    },
    scrollToTop() {
      setTimeout(() => {
        const selector = this.$el.querySelector('.md-preview');
        if (selector !== null) {
          selector.scrollIntoView();
        }
      }, 100);
    },
    initDisplay() {
      apiClient.get(apiList.accounts.status)
          .then(response => {
            if (this.hasResponseErrors(response)) {
              return;
            }
            this.isTrialUser = (response.data.status === Common.trialStatus);
            this.isTrialEnd  = (response.data.status === Common.trialEndedStatus);
          })
          .catch(error => {
            this.errorMessages = [error.message];
          });
    },
    isBillingWithFee() {
      return this.formData.bill_via !== Common.billingViaEmail;
    },
    showViaItem: function (item) {
      return this.formData.bill_method !== Common.billingMethodCreditCard || item === Common.billingViaEmail;
    },
    createFormData() {
      const form = {
        label        : this.formData.label,
        bill_via     : this.formData.bill_via,
        name1        : this.formData.name1,
        name2        : this.formData.name2,
        name3        : this.formData.name3,
        postal       : this.formData.postal,
        pref         : this.formData.pref,
        city         : this.formData.city,
        street_name  : this.formData.street_name,
        street_number: this.formData.street_number,
        etc          : this.formData.etc,
        email        : this.formData.email,
        meta         : {
          account_id: Common.getCurrentUserInfo().id,
        },
        bill_method  : this.formData.bill_method,
        corporation  : {
          name         : this.formData.corporation.name,
          branch_name  : this.formData.corporation.branch_name,
          postal       : this.formData.corporation.postal,
          pref         : this.formData.corporation.pref,
          city         : this.formData.corporation.city,
          street_name  : this.formData.corporation.street_name,
          street_number: this.formData.corporation.street_number,
          etc          : this.formData.corporation.etc,
        },
        account      : {
          name_last   : this.formData.account.name_last,
          name_first  : this.formData.account.name_first,
          email       : this.formData.account.email,
          tel         : this.formData.account.tel,
          t_service_id: this.formData.t_service_id,
        },
        contract     : {
          reason: this.formData.contract.reason,
        },
      };
      if (this.formData.bill_method === Common.billingMethodCreditCard) {
        form.card_token = this.formData.cardToken;
      }

      this.formData.additionalAddresses = this.formData.additionalAddresses.filter(email => email);
      Object.assign(form, {
        additional_addresses: this.formData.additionalAddresses.map(email => email)
      })

      return form;
    },
    /**
     * 登録処理
     */
    register() {
      this.sending          = true;
      this.validateResponse = [];
      apiClient.post(apiList.payment.payment_methods.register, this.createFormData())
          .then(response => {
            if (this.hasResponseErrors(response)) {
              if (this.validateResponse.length) {
                this.saveValidateResponse(this.validateResponse)
              }
              if (this.errorMessages.length) {
                this.saveErrorMessages(this.errorMessages)
              }
              this.sending = false;
              this.backToList();
              return;
            }
            if (response.data.gmo_member_id) {
              // 本契約時のみ登録が完了したメッセージを表示する
              this.getAuthAccountInformation();
            } else {
              this.sending       = false;
              this.errorMessages = [Common.messages.paymentMethod.insertError];
              this.saveErrorMessages(this.errorMessages)
              this.backToList();
            }
          })
          .catch(error => {
            this.sending       = false;
            this.errorMessages = [error.message];
            this.saveErrorMessages(this.errorMessages)
            this.backToList();
          })
          .finally(() => {
          });
    },
    /**
     * Fetch new auth account information
     */
    getAuthAccountInformation() {
      this.sending = true;
      apiClientWithUserToken
          .get(apiList.jon.accounts.auth)
          .then(response => {
            console.log('auth', response)
            if (this.hasResponseErrors(response)) {
              return;
            }
            console.log('auth 2', response)
            localStorage.removeItem(Common.localStorageKeys.user.auth);
            localStorage.setItem(Common.localStorageKeys.user.auth, JSON.stringify(response.data));
            this.showFeeExplanation = false;
            this.showRegistered     = true;
          })
          .catch(error => {
            console.log('auth error', error)
            this.errorMessages = [error.message];
          })
          .finally(() => {
            console.log('auth final')
            this.sending = false;
          });
    },
    /**
     * 登録完了メッセージダイアログを閉じる（本契約時のみ）
     */
    closeRegisteredDialog() {
      this.saveFormData(null);
      // 左メニューなどを再読込させるため暫定的な対応
      window.location.href = '/user/payments';
    },
    /**
     * 支払情報の名称を表示するか
     * @returns {boolean}
     */
    showPaymentLabel() {
      // トライアル期間中である場合、初回登録：デフォルト値であるため、支払情報の名称を非表示にする
      if (this.isTrialUser || this.isTrialEnd) {
        return false;
      }

      // 上記以外は、支払情報の名称を表示にする
      return true;
    }
  },
}
</script>

<style lang="scss" scoped>
@import "src/assets/scss/components.scss";

.mg-l-20 {
  margin-left: 20px;
}

.md-checked {
  color: #ff5252 !important;
}

.md-checkbox-checked {
  color: #44D644 !important;
}

.check-same-corp {
  margin-top: 16px;
}

button.check-same-corp {
  margin-left: 0;
  margin-top: 0;
}

.md-card-content-disabled {
  background-color: #f8f8f8;
}

.md-attention {
  color: #ff5252;
}

@media screen and (max-width: 1024px) {
  .check-same-corp {
    i {
      display: none;
    }
  }
}
</style>
